<template>
  <div>
    <v-row>
      <v-col
        v-for="(counter, index) in counters"
        :key="index"
        cols="auto"
      >
        <v-card outlined>
          <counter-card
            :loading="loading"
            :counter="counter"
            @select="v => $emit('select', v)"
          />
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<style>
.filtros {
  cursor: pointer;
}
.filtros:hover {
  background-color: rgba(196, 142, 255, 0.2);
}
</style>

<script >
import CounterCard from './CounterCard.vue'

export default {
  emits: ['select'],

  components: {
    CounterCard,
  },

  props: {
    loading: Boolean,
    counters: {
      type: Array,
      required: true,
    },
  },
}
</script>
